module.exports = __webpack_public_path__ + "img/plusBtn.065fc394.png";